module.exports = function(data) {
var __t, __p = '';
__p += '<div class="header">\n    <div class="btn-group">\n        <button type="button" class="btn btn-white quick">' +
((__t = ( strings.dropDownModeQuick )) == null ? '' : __t) +
'</button>\n        <button type="button" class="btn btn-light-blue multi">' +
((__t = ( strings.dropDownModeMulti )) == null ? '' : __t) +
'</button>\n    </div>\n</div>\n<div class="categories"></div>';
return __p
}